import { Subject, interval, timer } from "rxjs";
import { Component } from "@angular/core";
import { AuthenticationService } from "app/auth/service/authentication.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-renovate-session",
  templateUrl: "./renovate-session.component.html",
  styleUrls: ["./renovate-session.component.scss"],
})
export class RenovateSessionComponent {
  extend = false;
  expired: Subject<boolean> = this.authenticationService.isExpired;
  progressbarValue = 100;
  curSec = 0;
  isInTimer :boolean = false;
  public constructor(private authenticationService: AuthenticationService, private router: Router) {
    this.expired.subscribe(value => {
      if (value && this.authenticationService.isAuthenticated() && !this.isInTimer) {
        this.startTimer(60);
      }
    });
  }

  startTimer(seconds: number) {
    this.isInTimer = true;
    this.extend = false;
    this.progressbarValue = 100;
    this.curSec = 0;
    const timer$ = timer(0, 1000);
    const sub = timer$.subscribe((sec) => {
      this.curSec = this.curSec + 1;
      this.progressbarValue = 100 - this.curSec * 100 / seconds;

      if (this.curSec >= seconds && !this.extend) {
        this.expired.next(false);
        this.isInTimer= false;
        sub.unsubscribe();
        this.authenticationService.logout().then(td =>
          this.router.navigate(['auth','login'])
        );
      }
    });
  }

  async refreshToken() {
    await this.authenticationService.refreshToken().then(d => {
      this.expired.next(false);
      this.extend = true;
      this.progressbarValue = 100;
      this.curSec = 0;
    });
  }

}
